export default __webpack_public_path__ + "static/og-black-box-b9f9a4262df60694a7dbf59d8e41b8dc.jpg";